import collectionReducer from '../collectionReducer';

export default collectionReducer({
    apiCollectionName: 'persons',
    collectionActionName: 'USERS',
    itemActionName: 'USER',
});
